module.exports = __webpack_public_path__ + "static/media/tela_chat.4b33517c.svg";